import React from 'react';
import './ResearchDetails.css';

const ResearchDetails = () => {
  return (
    <section id="research-details" className="section research-details-section">
      <div className="container">
        <div className="section-title">
          <h2>Educational Foundations</h2>
          <p>The research and learning theories behind Nozomi Robotics</p>
        </div>

        <div className="research-content">
          <div className="research-text">
            <h3>Computational Thinking as a Core Skill</h3>
            <p>
              Nozomi Robotics is built on Jeannette Wing's framework that computational thinking is a fundamental skill for everyone.
              Our platform focuses on developing four key components:
            </p>
            <ul className="research-list">
              <li>
                <strong>Decomposition</strong> - Breaking down complex problems into smaller, manageable parts
              </li>
              <li>
                <strong>Pattern Recognition</strong> - Identifying similarities and patterns within problems
              </li>
              <li>
                <strong>Abstraction</strong> - Focusing on relevant information while filtering out unnecessary details
              </li>
              <li>
                <strong>Algorithmic Thinking</strong> - Developing step-by-step solutions to solve problems
              </li>
            </ul>

            <h3>Constructionism and Physical Computing</h3>
            <p>
              Inspired by Seymour Papert's theory of constructionism, Nozomi Robotics enables learning through making.
              By physically building and programming robots, users create tangible representations of abstract computational concepts.
            </p>
            <p>
              Research by Resnick et al. (2009) at MIT Media Lab shows that construction-oriented learning environments
              promote creative thinking and deeper understanding of complex concepts.
            </p>

            {/* <h3>Assessment Approach</h3>
            <p>
              Our challenges are designed using Dr. Shima Salehi's framework for assessment in computational
              thinking environments, focusing on progressive skill development and transfer of knowledge across domains.
            </p> */}

            {/* <div className="research-citation">
              <h4>Key Research References:</h4>
              <ul>
                <li>Wing, J. M. (2006). Computational thinking. Communications of the ACM, 49(3), 33-35.</li>
                <li>Papert, S. (1980). Mindstorms: Children, computers, and powerful ideas. Basic Books.</li>
                <li>Resnick, M., et al. (2009). Scratch: Programming for all. Communications of the ACM, 52(11), 60-67.</li>
                <li>Salehi, S., et al. (2020). Examining the relation between computational thinking and problem solving. Journal of Educational Computing Research.</li>
              </ul>
            </div> */}
          </div>

          {/* <div className="research-visual">
            <div className="research-diagram">
              <h4>Nozomi Robotics Learning Model</h4>
              <img src="/placeholder-diagram.jpg" alt="Nozomi Robotics Learning Model" />
              <p className="diagram-caption">Our cyclical approach to developing computational thinking skills through robotics</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ResearchDetails;